import React from 'react'

const PassPageContext = React.createContext(null)

export default PassPageContext
